import { useMemo } from 'react';
import { ChevronUpDownIcon } from '@heroicons/react/24/outline';
import Typography from '@/components/atoms/typography';
import { TableCellProps } from '../types';
import { classnames } from '@/utils/classnames/classnames';

const TableCell = ({
  className,
  sortable,
  isButtonsCell = false,
  isButtonsHead = false,
  onSorting,
  children,
  ...props
}: TableCellProps) => {
  const cellClassName = classnames(
    'p-[10px]',
    { 'cursor-pointer': !!sortable },
    { 'bg-white': isButtonsCell },
    { 'bg-[#FCFCFD]': isButtonsHead },
    { 'shadow-[0px_-1px_0px_0px_#E4E4E7_inset] lg:shadow-none': isButtonsCell || isButtonsHead },
    {
      'sticky right-[0px] z-10 lg:block lg:bg-transparent': isButtonsCell || isButtonsHead,
    },
    { 'text-right': typeof children == 'number' },
    className,
  );

  const asTypography = useMemo(
    () => (
      <Typography className="!leading-6">
        {children as string}
      </Typography>
    ),
    [children],
  );

  const childrenContainer = useMemo(() => {
    if (sortable) {
      return (
        <div className="flex gap-[2px]">
          {asTypography}
          <ChevronUpDownIcon onClick={onSorting} className="hidden h-[5px] w-[5px] stroke-gray-500 lg:block" />
        </div>
      );
    } else if (typeof children === 'string') return asTypography;
    else return children;
  }, [asTypography, children, onSorting, sortable]);

  return (
    <td className={cellClassName} {...props}>
      {childrenContainer}
    </td>
  );
};

export default TableCell;